// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v758D","placeholdersHeader":"styles_placeholdersHeader__2MuRo","editorStyle":"styles_editorStyle__1eA-n","placeholdersBox":"styles_placeholdersBox__2aupr"};